__turbopack_context__.v({
  "border": "page-title-module__F-ePyq__border",
  "breadcrumbLink": "page-title-module__F-ePyq__breadcrumbLink",
  "breadcrumbs": "page-title-module__F-ePyq__breadcrumbs",
  "containerHeroTitle": "page-title-module__F-ePyq__containerHeroTitle",
  "currentBreadcrumb": "page-title-module__F-ePyq__currentBreadcrumb",
  "description": "page-title-module__F-ePyq__description",
  "innerWrapper": "page-title-module__F-ePyq__innerWrapper",
  "outerWrapper": "page-title-module__F-ePyq__outerWrapper",
  "title": "page-title-module__F-ePyq__title",
});
